// 投放到中石油自建app的链接
// source: 'cnpc',
// appname: 'kssl',
// platform: 'web'

module.exports = {
  hlid: "hlM3EIWI",
};
